import { Outlet } from 'react-router-dom'
import styled from 'styled-components'

import { Information } from 'components/Information'
import { Transcript } from 'components/Transcript'
import { AppScreen } from 'components/layouts/styles'
import { useEsConfig } from 'hooks/useEsConfig'
import { pxToRem } from 'theme/utils'

const Modals = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  left: 0;
  right: 0;
  // Always set a height to avoid layout shifts
  min-height: ${pxToRem(158)};
`

export const PlayerView = (): JSX.Element => {
  const esConfig = useEsConfig()
  return (
    <AppScreen>
      <Outlet />
      <Modals>
        <Information content={esConfig} />
        <Transcript content={esConfig} />
      </Modals>
    </AppScreen>
  )
}
